import { Currency as CurrencyType } from '../types/payment';

class Currency {
  format(obj: CurrencyType, locale = 'en') {
    const { amount, currency, minor } = obj;
    const value = amount / 10 ** minor;
    const options = {
      currencyDisplay: 'code',
      currency,
      style: 'currency',
      minimumFractionDigits: minor,
      maximumFractionDigits: minor,
    };
    return new Intl.NumberFormat(locale, options).format(value);
  }

  parse(obj: CurrencyType) {
    const { amount, minor } = obj;
    return amount / 10 ** minor;
  }

  convert(naturalAmount: number, currency: string, locale = 'en') {
    const { maximumFractionDigits: minor } = new Intl.NumberFormat(locale, {
      currency,
      style: 'currency',
    }).resolvedOptions();

    return { amount: naturalAmount * 10 ** minor, currency, minor };
  }
}

export const currencyList = [
  { code: 'AED', name: 'United Arab Emirates Dirham' },
  { code: 'ARS', name: 'Argentinian Peso' },
  { code: 'AUD', name: 'Australian Dollar' },
  { code: 'BRL', name: 'Brazilian Real' },
  { code: 'CAD', name: 'Canadian Dollar' },
  { code: 'CHF', name: 'Swiss Francs' },
  { code: 'CNY', name: 'Chinese Renminbi' },
  { code: 'CZK', name: 'Czech Republic Koruny' },
  { code: 'DKK', name: 'Danish Krone' },
  { code: 'EGP', name: 'Egyptian Pound' },
  { code: 'EUR', name: 'Euro' },
  { code: 'GBP', name: 'British Pound Sterling' },
  { code: 'HKD', name: 'Hong Kong Dollar' },
  { code: 'HUF', name: 'Hungarian Forint' },
  { code: 'IDR', name: 'Indonesian Rupiah' },
  { code: 'ILS', name: 'Israeli Shekel' },
  { code: 'INR', name: 'Indian Rupee' },
  { code: 'JPY', name: 'Japanese Yen' },
  { code: 'KES', name: 'Kenyan Schilling' },
  { code: 'KRW', name: 'South Korean Won' },
  { code: 'MXN', name: 'New Mexican Peso' },
  { code: 'MOP', name: 'Macau Patacas' },
  { code: 'MYR', name: 'Malaysian Ringgits' },
  { code: 'NOK', name: 'Norwegian Krone' },
  { code: 'NZD', name: 'New Zealand Dollar' },
  { code: 'PHP', name: 'Philippine Peso' },
  { code: 'PKR', name: 'Pakistan Rupee' },
  { code: 'PLN', name: 'Polish Zloty' },
  { code: 'RUB', name: 'Russian Rouble' },
  { code: 'SAR', name: 'Saudi Arabian Riyal' },
  { code: 'SEK', name: 'Swedish Krona' },
  { code: 'SGD', name: 'Singapore Dollar' },
  { code: 'THB', name: 'Thailand Baht' },
  { code: 'TRY', name: 'New Turkish Lira' },
  { code: 'TWD', name: 'New Taiwan Dollar' },
  { code: 'USD', name: 'U.S. Dollar' },
  { code: 'ZAR', name: 'South African Rand' },
];

export default new Currency();
